<script setup lang="ts">
import IconFullwith from '~icons/icon-park-outline/fullwidth'
import { useTabStore, useTrackerStore } from '@/store'
import { renderIcon } from '@/utils'

const trackerStore = useTrackerStore()

const tabStore = useTabStore()

function renderDropTabsLabel(option: any) {
  return option.meta.title
}
function renderDropTabsIcon(option: any) {
  return renderIcon(option.meta.icon)!()
}

const router = useRouter()
function handleDropTabs(key: string, option: any) {
  router.push(option.path)
}

function handleClose() {
  trackerStore.lastSelectedKey = '/'
  tabStore.closeAllTabs()
}
</script>

<template>
  <!-- <n-dropdown
    :options="tabStore.allTabs"
    trigger="click"
    size="small"
    :render-label="renderDropTabsLabel"
    :render-icon="renderDropTabsIcon"
    @select="handleDropTabs"
  >
    <CommonWrapper>
      <icon-park-outline-application-menu />
    </CommonWrapper>
  </n-dropdown> -->
  <n-tooltip placement="bottom" trigger="hover">
    <template #trigger>
      <CommonWrapper v-track="{ type: 'Icon_Button', data: '关闭全部', public: true }" @click="handleClose">
        <IconFullwith />
      </CommonWrapper>
    </template>
    <span>关闭全部</span>
  </n-tooltip>
</template>

<style scoped>

</style>
